import React, { Component } from 'react';
import ButtonAlt from "../../ButtonAlt/ButtonAlt";
import './NoResults.css';

class NoResults extends Component {
	render(){
		return(
			<div className="no-results container">
				<p>Sorry, your search returned 0 results. Please try again.</p>
				<ButtonAlt
					label="Back to Search"
					onClick={() => this.props.changeLocation("/dashboard/search")}
				/>
			</div>
			)
	}
}

export default NoResults;


// WEBPACK FOOTER //
// ./src/components/SearchResults/NoResults/NoResults.js